/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS GPS lost detection api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PageStatVoyPosReportSchema
 */
export interface PageStatVoyPosReportSchema {
    /**
     * 
     * @type {any}
     * @memberof PageStatVoyPosReportSchema
     */
    items: any | null;
    /**
     * 
     * @type {any}
     * @memberof PageStatVoyPosReportSchema
     */
    total: any | null;
    /**
     * 
     * @type {any}
     * @memberof PageStatVoyPosReportSchema
     */
    page: any | null;
    /**
     * 
     * @type {any}
     * @memberof PageStatVoyPosReportSchema
     */
    size: any | null;
    /**
     * 
     * @type {any}
     * @memberof PageStatVoyPosReportSchema
     */
    pages?: any | null;
}

/**
 * Check if a given object implements the PageStatVoyPosReportSchema interface.
 */
export function instanceOfPageStatVoyPosReportSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "size" in value;

    return isInstance;
}

export function PageStatVoyPosReportSchemaFromJSON(json: any): PageStatVoyPosReportSchema {
    return PageStatVoyPosReportSchemaFromJSONTyped(json, false);
}

export function PageStatVoyPosReportSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageStatVoyPosReportSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': json['items'],
        'total': json['total'],
        'page': json['page'],
        'size': json['size'],
        'pages': !exists(json, 'pages') ? undefined : json['pages'],
    };
}

export function PageStatVoyPosReportSchemaToJSON(value?: PageStatVoyPosReportSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items,
        'total': value.total,
        'page': value.page,
        'size': value.size,
        'pages': value.pages,
    };
}

